import { Toast, initTE } from 'tw-elements';
initTE({ Toast });

export class NotificationsManager {
    private types: {
        NOTIFICATION_SUCCESS: 'NOTIFICATION_SUCCESS',
        NOTIFICATION_WARNING: 'NOTIFICATION_WARNING',
        NOTIFICATION_ERROR: 'NOTIFICATION_ERROR'
    }
    private toastElement: HTMLElement
	constructor() {
		this.types = {
            NOTIFICATION_SUCCESS: 'NOTIFICATION_SUCCESS',
            NOTIFICATION_WARNING: 'NOTIFICATION_WARNING',
            NOTIFICATION_ERROR: 'NOTIFICATION_ERROR'
        };
        this.toastElement = document.getElementById('message-success')!;

        const params = new URLSearchParams(window.location.search)
        if (params.get('login') === 'success') {
            this.open({
                type: this.types.NOTIFICATION_SUCCESS,
                body: "you are logged in!"
            });
        }
        if (params.get('login') === 'logout') {
            this.open({
                type: this.types.NOTIFICATION_SUCCESS,
                body: "you are logged out."
            });
        }
        if (params.get('login') === 'failed_login') {
        this.open({
                type: this.types.NOTIFICATION_ERROR,
                body: `we're sorry, but we don't recognize your sign in.\n
                you may want to try resetting your password.\n
                if you need additional help, please email us at contact@cletile.com\n
                `
            });
        }
        if (params.get('login') === 'already_exists') {
            this.open({
                type: this.types.NOTIFICATION_ERROR,
                body: "a customer with the exact same email address already exists."
            });
        }
        if (params.get('login') === 'password_reset') {
            this.open({
                type: this.types.NOTIFICATION_SUCCESS,
                body: "successfully changed password."
            });
        }
	}

    open(Notification: { type?: 'NOTIFICATION_SUCCESS' | 'NOTIFICATION_ERROR' | 'NOTIFICATION_WARNING'; body: string; callback?: (() => void) | undefined; }) {
        switch (Notification.type) {
            case 'NOTIFICATION_SUCCESS':
            default:
                this.toastElement = document.getElementById('message-success')!;
                break;
            case 'NOTIFICATION_ERROR':
                this.toastElement = document.getElementById('message-error')!;
                break;
            case 'NOTIFICATION_WARNING':
                this.toastElement = document.getElementById('message-warning')!;
                break;
        }
    
        if (this.toastElement) {
            const text = this.toastElement.getElementsByTagName('p')[0];
    
            if (text) {
                text.innerHTML = Notification.body;
    
                const instance = Toast.getOrCreateInstance(this.toastElement, {
                    autohide: true,
                    position: 'top-left'
                });
    
                const callbackWrapper = (event: any) => {
                    let target = event.target as HTMLElement;
                    if ((target.tagName === 'BUTTON' || target.tagName === 'SPAN') && target.textContent === 'OK') {
                        Notification.callback && Notification.callback();
                        instance.hide();
                        this.toastElement.removeEventListener('click', callbackWrapper);
                    }
                };
    
                this.toastElement.removeEventListener('click', callbackWrapper);
                if (Notification.callback !== undefined) {
                    this.toastElement.addEventListener('click', callbackWrapper);
                }
    
                instance.show();
            }
        }
    }
    
}

declare global {
    interface Window {
        notificationsManager: any;
    }
  }

window.notificationsManager = new NotificationsManager()
